



























import {Component, Vue, Provide} from 'vue-property-decorator'
import langs from '@/data/i18n/languages.json'

@Component
export default class AppLocales extends Vue {

    //Data
    @Provide() languages: any[] = langs

    get currentLanguage() {
        const locale = this.$i18n.locale
        return this.languages.find(l => l.alternate === locale || l.locale === locale)
    }

    //Methods
    changeLocale(language: any) {
        this.$i18n.locale = language.locale
        this.$vuetify.lang.current = language.locale
    }
}
